import React from 'react';
import { RouteProps } from 'react-router-dom';
import { authMenu } from 'menu';
import DefaultAside from 'pages/_layout/_asides/DefaultAside';

const asides: RouteProps[] = [
	{ path: '*', element: <DefaultAside /> },
	{ path: authMenu.login.path, element: null },
	{ path: authMenu.joinTeam.path, element: null },
	{ path: authMenu.confirmLogin.path, element: null },
	{ path: authMenu.forgetGroup.subMenu.forgetPassword.path, element: null },
	{ path: authMenu.forgetGroup.subMenu.confirmation.path, element: null },
	{ path: authMenu.confirmSignUp.path, element: null },
	{ path: authMenu.forgetGroup.subMenu.resetPassword.path, element: null },
	{ path: `${authMenu.joinTeam.path}/:slug`, element: null },
];

export default asides;
